/******************************************
 * emartmall
 *
 * @author          Luke.kim
 * @copyright       Copyright (c) 2013 emart.
 * @license         This is dual licensed under the MIT and GPL licenses.
 * @version         0.7.2
 * @description     수정시에는 modify 태그에 수정부분에 대한 설명을 적을것, 코드 수정 이후에는 수정자가 코드 품질 보장.
 * @since           2013-08-29 10:04
 * @modify          2014-04-28 18:43
 * @uses            jindo.m.SlideFlicking
 * @history         0.6.2 버튼 on, off 클래스 추가 및 disable/enable 속성 추가
 * @history         0.6.3 2개이면서 순환일때 예외처리 추가
 * @history         0.6.4 플리킹 공통 메서드 추가 refresh, moveNext, movePrev
 * @history         0.6.5 1개이면서 순환일때 예외처리 추가
 * @history         0.6.6 bPreventTouch 추가 설정시 터치 먹지 않음
 * @history         0.6.7 bImageReady 추가 설정시 이벤트 트리거 발생: loadAllImage
 * @history         0.6.8 이미지 에러시 처리 이벤트 추가 loadAllImage error
 * @history         0.6.9 공통 메서드 추가 isMoving, resetAutoplay
 * @history         0.7.0 bEnableAfterPagination 이벤트 시점 추가
 * @history         0.7.1 34735이슈 해결을 위해 수정사항 추가 순환모드시 모든 버튼 활성화, 컨텐츠 갯수에 따라 버튼 숨김
 * @history         0.7.2 자동 모드 시 방향 방향설정(bReverse) 추가
 ******************************************/
(function ($, window, document) {

    'use strict';

    var pluginName = 'flicking',
        defaults = {
            nDefaultIndex: 0,
            nTotalContents: null,
            bUseCss3d: oSupport.bUseCss3d,
            bUseDiagonalTouch: false,
            sClassPrefix: 'flick-',
            sContentClass: 'ct',
            bUseCircular: false,  //순환여부
            bAutoPlay: false,
            bPreventTouch: false,
            nAutoPlayTime: 3000,
            bAutoResize: true,
            bReverse: false,
            bImageReady: false,
            bSupportPagination: false,
            bEnableAfterPagination: true,
            //elPagination : '.flick-paging .ico-cir',
            elPagination: '.flick-paging>span',
            sPaginationClass: 'paging-on',
            bSupportBtn: false,
            elPrevBtn: null,
            elNextBtn: null,
            sOnBtnClass: 'on',
            sOffBtnClass: 'off',
            fnComplete: null,
            nDuration: 100,
            nDefaultDuration: 100
            //fpPanelEffect: jindo.m.Effect.easeIn,
            //nFlickThreshold: 40,
            //nBounceDuration: 100,
            //nDeceleration: .001,
            //bUseMomentum: !1
        };

    function Flicking(element, options) {
        this.el = element;
        this.wel = $(element);
        this.options = $.extend({}, defaults, options);
        this._aFlickData = [];
        this._bMoreFlickControl = false;
        this._welPagination = null;
        this._autoPlayIntervalId = null;
        this._defaults = defaults;
        this._name = pluginName;
        this._abnoramlFlag = false;

        this.init();
    }

    Flicking.prototype = {
        init: function () {
            this._beforeInitFlicking();
            this._initFlicking();
            this._afterInitFlicking();
            this._attachFlickEvent();

            if (this.options.bSupportPagination) {
                this._initPagination();
            }

            if (this._canSupportMovingBtn()) {
                this._attachMovingBtnEvent();
            }

            if (this.options.bAutoPlay && this.options.bUseCircular) {
                this._startAutoplay();
            }

            if($.isFunction(this.options.fnComplete)){
                this.options.fnComplete.call(this);
            }
        },
        _beforeInitFlicking: function () {
            this._needMoreFlickControl();

            if (this.options.nTotalContents === null) {
                this.options.nTotalContents = this._getFlickContainer().length;
            }

            if (this._bMoreFlickControl) {
                this._makeFlickElements();
            }

            if (this.options.bUseCircular && this.options.nTotalContents === 2) {
                //Only if there exist three panels possible circular.
                this._makeFlickElements();
                this._addLastFlickContainer();
            }

            if (this.options.bUseCircular && this.options.nTotalContents === 1) {
                this.options.bUseCircular = false;
            }

            /*if (this._canSupportMovingBtn() && this.options.nTotalContents === 1) {
                this._hideMovingBtn();
            }*/
           if (this._canSupportMovingBtn() && this.options.bUseCircular) {
                this._activateAllMovingBtn();
            }
        },
        _initFlicking: function () {
            this._welFlicking = new jindo.m.SlideFlicking(this.el, this.options);
        },
        _initFlickingContainers: function () {
            this._welFlicking.getElement().html(this._aFlickData[this._welFlicking.getContentIndex()]);
            this._welFlicking.getNextElement().html(this._aFlickData[this._welFlicking.getNextIndex()]);
            this._welFlicking.getPrevElement().html(this._aFlickData[this._welFlicking.getPrevIndex()]);
        },
        _initPagination: function () {
            //this._welPagination = this.wel.find(this.options.elPagination).parent();
            this._welPagination = this.wel.find(this.options.elPagination);
        },
        _afterInitFlicking: function () {
            this._showFlickingContainers();
            if (this.options.bUseCircular && this._bMoreFlickControl) {
                this.wel.find(".flick-ct:gt(2)").remove();
                this._refreshFlickingContainer(this.options.nDefaultIndex);
                this._initFlickingContainers();
            }

            if (this.options.bImageReady) {
                this._onImageLoaded();
            }
        },
        _attachFlickEvent: function () {
            var oSelf = this;

            if (this.options.bUseCircular && this.options.nTotalContents === 2) {
                this._welFlicking.attach('flicking', $.proxy(this._onAbnormalFlicking, this));
            } else {
                this._welFlicking.attach('flicking', $.proxy(this._onFlicking, this));
            }
            this._welFlicking.attach('beforeFlicking', $.proxy(this._onBeforeFlicking, this));
            this._welFlicking.attach('beforeRestore', $.proxy(this._onBeforeRestore, this));
            this._welFlicking.attach('restore', $.proxy(this._onRestore, this));
            this._welFlicking.attach('move', $.proxy(this._onMove, this));

            //this._welFlicking.attach('touchStart ', $.proxy(this._onTouchStart, this));
            // when autoplaying can't touch
            if (oSelf.options.bPreventTouch) {
                this._welFlicking.attach('beforeTouchStart', $.proxy(this._onTouchStop, this));
                //this._welFlicking.attach('touchStart', $.proxy(this._onTouchStop, this));
            }

            if (oSelf.options.bAutoPlay) {
                this._welFlicking.attach('touchStart', $.proxy(this._onTouchStart, this));
                this._welFlicking.attach('touchEnd', $.proxy(this._onTouchEnd, this));
            }
        },
        _attachMovingBtnEvent: function () {
            var welPrevBtn  = $(this.options.elPrevBtn),
                welNextBtn  = $(this.options.elNextBtn);

            welPrevBtn.on('click', $.proxy(this._onClickPrevBtn, this));
            welNextBtn.on('click', $.proxy(this._onClickNextBtn, this));
        },
        _onAbnormalFlicking: function (oCustomEvt) {
            var sData = '',
                nIdx = null,
                nPage = null;

            nIdx = this._abnoramlFlag ? 1 : 0;
            nPage = this._abnoramlFlag ? 0 : 1;
            sData = this._aFlickData[nIdx];
            this._abnoramlFlag = !this._abnoramlFlag;
            this._welFlicking.getPrevElement().html(sData);
            this._welFlicking.getNextElement().html(sData);

            if (this.options.bSupportPagination) {
                this._activatePagination(nPage);
            }

            this.triggerEvent(oCustomEvt);
        },
        _onFlicking: function (oCustomEvt) {
            if (this._bMoreFlickControl) {
                if (oCustomEvt.bCorrupt) {
                    // 전체 panel의 정보가 바뀔경우. 3개 panel의 모든 정보를 바꾼다.
                    this._initFlickingContainers();
                } else {
                    this._welFlicking.getPrevElement().html(this._aFlickData[this._welFlicking.getPrevIndex()]);
                    this._welFlicking.getNextElement().html(this._aFlickData[this._welFlicking.getNextIndex()]);
                }
            }

            if (this.options.bSupportPagination && this.options.bEnableAfterPagination) {
                this._activatePagination(oCustomEvt.nContentsIndex);
            }

            if (this._canSupportMovingBtn() && !!!this.options.bUseCircular) {
                this._activateMovingBtn(oCustomEvt.nContentsIndex);
            }

            this.triggerEvent(oCustomEvt);
        },
        _onBeforeFlicking: function (oCustomEvt) {
            if (this.options.bSupportPagination && !this.options.bEnableAfterPagination) {
                this._activatePagination(oCustomEvt.nContentsNextIndex);
            }

            this.triggerEvent(oCustomEvt);
        },
        _onBeforeRestore: function (oCustomEvt) {
            this.triggerEvent(oCustomEvt);
        },
        _onRestore: function (oCustomEvt) {
            this.triggerEvent(oCustomEvt);
        },
        _onMove: function (oCustomEvt) {
            this.triggerEvent(oCustomEvt);
        },
        _onTouchStart: function (oCustomEvt) {
            //this._welFlicking.option('nDuration', 100);
            this._stopAutoplay();
            this.triggerEvent(oCustomEvt);
        },
        _onTouchEnd: function (oCustomEvt) {
            this._startAutoplay();
            this.triggerEvent(oCustomEvt);
        },
        _onTouchStop: function (oCustomEvt) {
            oCustomEvt.stop();
        },
        triggerEvent: function (oCustomEvt) {
            this.wel.trigger(oCustomEvt.sType, [oCustomEvt]);
        },
        _onClickPrevBtn: function (e) {
            //빠른 터치 방어
            //if(this._welFlicking.isPlaying()){};
            var welPrevBtn = $(this.options.elPrevBtn),
                sOnBtnClass = this.options.sOnBtnClass;

            if (welPrevBtn.hasClass(sOnBtnClass)) {
                //this._welFlicking.movePrev();
                this.movePrev();
            }
        },
        _onClickNextBtn: function (e) {
            //if(this._welFlicking.isPlaying()){};
            var welNextBtn = $(this.options.elNextBtn),
                sOnBtnClass = this.options.sOnBtnClass;

            if (welNextBtn.hasClass(sOnBtnClass)) {
                //this._welFlicking.moveNext();
                this.moveNext();
            }
        },
        _getFlickContainer: function () {
            var sFlickContainerClass = '.' + this.options.sClassPrefix + this.options.sContentClass;

            return this.wel.find(sFlickContainerClass);
        },
        _addLastFlickContainer: function () {
            var sFlickContainerClass = '.' + this.options.sClassPrefix + this.options.sContentClass,
                welLastFlickContainer = this.wel.find(sFlickContainerClass).last();

            welLastFlickContainer.after(welLastFlickContainer.clone());
        },
        _showFlickingContainers: function () {
            var welFlickingContainers = this._getFlickContainer();

            welFlickingContainers.show();
        },
        _refreshFlickingContainer: function (nIdx) {
            this._welFlicking.refresh(nIdx);
        },
        _canSupportMovingBtn: function () {
            return (!!this.options.elPrevBtn && !!this.options.elNextBtn);
        },
        _needMoreFlickControl: function () {
            var nFlickContainer = this._getFlickContainer().length;

            if (nFlickContainer > 3) {
                this._bMoreFlickControl = true;
            }
        },
        _makeFlickElements: function () {
            var sFlickContainerClass = '.' + this.options.sClassPrefix + this.options.sContentClass;

            this._aFlickData = this.wel.find(sFlickContainerClass).map(function () {
                return $(this).html();
            });
        },
        _activatePagination: function (nIdx) {
            var sActiveClass = this.options.sPaginationClass;

            this._welPagination
                .removeClass(sActiveClass)
                .eq(nIdx).addClass(sActiveClass);
        },
        _activateMovingBtn: function (nIdx) {
            var welPrevBtn = $(this.options.elPrevBtn),
                welNextBtn = $(this.options.elNextBtn),
                nTotalIdx = this.options.nTotalContents - 1,
                sOnBtnClass  = this.options.sOnBtnClass,
                sOffBtnClass = this.options.sOffBtnClass;

            if (nIdx === 0) {
                welPrevBtn.removeClass(sOnBtnClass).addClass(sOffBtnClass).prop('disabled', true);
                welNextBtn.removeClass(sOffBtnClass).addClass(sOnBtnClass).prop('disabled', false);
            } else if (nIdx === nTotalIdx) {
                welPrevBtn.removeClass(sOffBtnClass).addClass(sOnBtnClass).prop('disabled', false);
                welNextBtn.removeClass(sOnBtnClass).addClass(sOffBtnClass).prop('disabled', true);
            } else {
                welPrevBtn.removeClass(sOffBtnClass).addClass(sOnBtnClass).prop('disabled', false);
                welNextBtn.removeClass(sOffBtnClass).addClass(sOnBtnClass).prop('disabled', false);
            }
        },
        _activateAllMovingBtn: function(){
            var welPrevBtn = $(this.options.elPrevBtn),
                welNextBtn = $(this.options.elNextBtn),
                sOnBtnClass  = this.options.sOnBtnClass,
                sOffBtnClass = this.options.sOffBtnClass;

            welPrevBtn.removeClass(sOffBtnClass).addClass(sOnBtnClass).prop('disabled', false);
            welNextBtn.removeClass(sOffBtnClass).addClass(sOnBtnClass).prop('disabled', false);
        },
        //_onImageLoaded: function (fnCallBack) {
        _onImageLoaded: function () {
            //var welFlickingContainers = this._getFlickContainer(),
            var welFlickingContainers = $(this._welFlicking.getElement().$value()),
                welImgs = welFlickingContainers.find('img'),
                nImg = welImgs.length,
                oSelf = this;

            //welImgs.bind('load', function () {
            welImgs.bind('load error', function () {
                if (--nImg <= 0) {
                    oSelf.wel.trigger('loadAllImage');
                    //console.log("all complete");
                    //fnCallBack.call(welImgs,this);
                    //all complete
                }
            }).each(function () {
                // cached images don't fire load sometimes, so we reset src.
                if (this.complete || this.complete === undefined) {
                    var src = this.src;
                    // complete
                    // webkit hack from http://groups.google.com/group/jquery-dev/browse_thread/thread/eee6ab7b2da50e1f
                    // data uri bypasses webkit log warning (thx doug jones)
                    this.src = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==";
                    this.src = src;
                }
            });
        },
        _startAutoplay: function () {
            var oSelf = this;

            this._autoPlayIntervalId = setInterval(function () {
                if (oSelf.options.nTotalContents >= 2) {
                    if(oSelf.options.bReverse){
                        oSelf._welFlicking.movePrev();
                    }else{
                        oSelf._welFlicking.moveNext();
                    }
                }
                /*else{
                    if(oSelf._welFlicking.getContentIndex() === oSelf.options.nTotalContents-1){
                        oSelf._welFlicking.movePrev();
                    }else{
                        oSelf._welFlicking.moveNext();
                    }
                }*/
            }, this.options.nAutoPlayTime);
        },
        _stopAutoplay: function () {
            if (this._autoPlayIntervalId) {
                clearInterval(this._autoPlayIntervalId);
                this._autoPlayIntervalId = null;
            }
        },
        isMoving: function(){
            return this._welFlicking.isPlaying();
        },
        resetAutoplay: function(){
            if (this.options.bAutoPlay) {
               this._stopAutoplay();
               this._startAutoplay();
            }
        },
        refresh: function (nIdx) {
            this._welFlicking.refresh(nIdx);
        },
        moveNext: function () {
            this._welFlicking.moveNext();
        },
        movePrev: function () {
            this._welFlicking.movePrev();
        },
        hideMovingBtn: function(){
            var welPrevBtn = $(this.options.elPrevBtn),
                welNextBtn = $(this.options.elNextBtn);

            welPrevBtn.hide();
            welNextBtn.hide();
        },
        activatMovingBtnByContent: function(){
            if(this._getFlickContainer().length <= 1){
                this.hideMovingBtn();
            }
        }
    };
    $.fn[pluginName] = function (options) {
        return this.each(function () {
            if (this.style.display === 'none') {
                // trigger evnet once when element display block
                /*$(this).one("visible", function() {
                 alert("This will be displayed only once.");
                 });*/
                return;
            }

            if (!$.data(this, "plugin_" + pluginName)) {
                $.data(this, "plugin_" + pluginName,
                    new Flicking(this, options));
            } else if ($.isFunction(Flicking.prototype[options])) {
                $.data(this, 'plugin_' + pluginName)[options]();
            }
        });
    };
    //window.Flicking = Flicking;
})(jQuery, window, document);